export const CoreInitiativesCommentsName = 'CoreInitiativesComments';
